import { WebAuthClient } from "@terveystalo/web-auth-onewelcome"
import { authLogger } from "./auth-logger"
import { config } from "./config"

export const authConfig = {
  authority: config.oidcAuthority,
  client_id: config.oidcClientId,
  redirect_uri: config.oidcRedirectUri,
  post_logout_redirect_uri: config.oidcPostLogoutRedirectUri,
  // Only include silent_redirect_uri if it's configured
  ...(config.oidcSilentRedirectUri && {
    silent_redirect_uri: config.oidcSilentRedirectUri,
  }),
  scope: "openid profile",
}

authLogger.log("[UserManager] Auth configuration:", authConfig)

const authClient = new WebAuthClient(authConfig)

// Log when signinRedirect is called
const originalSigninRedirect = authClient.signinRedirect.bind(authClient)
authClient.signinRedirect = async (args?: Parameters<typeof originalSigninRedirect>[0]) => {
  authLogger.log("[UserManager] signinRedirect called with args:", args)
  authLogger.log("[UserManager] Current window.location:", window.location.href)
  try {
    const result = await originalSigninRedirect(args)
    authLogger.log("[UserManager] signinRedirect result:", result)
    return result
  } catch (error) {
    authLogger.error("[UserManager] signinRedirect error:", error)
    throw error
  }
}

export default authClient
